<template>
  <v-dialog
    :value="value"
    persistent
    max-width="1000"
  >
    <v-card>
      <component
        :is="componentName"
        :id="id"
        :key="id"
        :is-modal-close="isModalClose"
        :modal="true"
        :modal-mode="value"
        @close="close"
      />
      <slot />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    Payment() {
      return import("../views/operations/payments/Payment.vue");
    },
    Invoice() {
      return import("../views/operations/invoices/Invoice.vue");
    },
    Manager() {
      return import("../views/catalogs/managers/Manager.vue");
    },
    Service() {
      return import("../views/catalogs/services/Service.vue");
    },
    Client() {
      return import("../views/catalogs/clients/Client.vue");
    },
    Product() {
      return import("../views/catalogs/products/Product.vue");
    },
    Employee() {
      return import("../views/catalogs/employees/Employee.vue");
    },
    Payer() {
      return import("../views/catalogs/payers/Payer.vue");
    },
    PaymentPackage() {
      return import("../views/catalogs/payment-packages/PaymentPackage.vue");
    },
    PaymentSource() {
      return import("../views/catalogs/payment-sources/PaymentSource.vue");
    },
    ProductCategory() {
      return import("../views/catalogs/product-categories/ProductCategory.vue");
    },
    ServiceType() {
      return import("../views/catalogs/service-types/ServiceType.vue");
    },
    Project() {
      return import("../views/catalogs/projects/Project.vue");
    },
    Specification: () =>
      import("../views/operations/specifications/Specification.vue"),
    Department: () => import("../views/catalogs/departments/Department.vue"),
    CrmCompany: () => import("../Crm/views/companies/Company.vue"),
  },
  props: ["componentName", "id", "value"],
  data() {
    return {
      isModalClose: false,
    };
  },
  methods: {
    close() {
      this.isModalClose = !this.isModalClose;
      this.$emit("input");
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}

.modal__btn {
  pointer-events: auto;
}
</style>
